import moment from 'moment';

export default function(state) {
    let names = state.questions.map(question => question.name);
    let formats = {};

    state.questions.forEach(q => {
        formats[q.name] = q.inputFormat;
    });

    let controlGroups = state.questions.map(
        question => question.attributes && question.attributes.controlGroup
    );
    let supplementalQuestions = state.supplementalQuestions.map(question => question.name);
    let supplementalRadioQuestions = state.supplementalQuestions.map(question => {
        if (question.inputType === 'radio') {
            return question.name;
        }
    }).filter(Boolean)

    names = names.concat(supplementalQuestions);

    let values = names.reduce((obj, name, idx) => {
        let val;
        if (state.isSameAddress && name === 'projectAddress') {
            if (state.addressValues) {
                val = state.addressValues[name];
            }
        }
        else {
        if (!document.getElementById(name) && !document.querySelector(`.${name} input`)) return obj;
        //Read radio buttons
        if (document.querySelector(`.${name} input`)) {
            let option = document.querySelector(`.${name} input:checked`);
            if (!option) {

                let supOption = document.querySelector(`.${name}`).classList.contains('radio') &&
                supplementalRadioQuestions.includes(name)
                if (supOption) {
                    val = ''
                } else {
                    return obj
                }
            } else {
                val = option.value;
            }
        } else if (document.getElementById(name).classList.contains('dropdown')) {
            val = document.getElementById(name).value;
        } else if
        (document.getElementById(name).classList.contains('selectFormDropdown')) {
            val = document.getElementById(name).getAttribute("value");
        } else {
            //Else read form elements by id
            val = document.getElementById(name).value;

            if (document.getElementById(name).classList.contains('number-control')) {
                val = val.replace(/[,$]/g, '');
            }

            //get all select values
            if (document.getElementById(name).type === 'select-multiple') {
                val = Array.from(document.querySelector('#excessLimit').children)
                    .filter(child => child.selected)
                    .map(child => child.value);
            }

            if (val !== '' && formats[name] === 'date') val = moment(val, 'MM-DD-YYYY').format('YYYY-MM-DD');
        }

        if (name === 'primaryInsuredAddress' || name === 'projectAddress') {
            if (state.addressValues) {
                val = state.addressValues[name];
            }
        }
    }

        if (name === 'projectRequirements') {
            val = Array.from(document.querySelectorAll('.projectRequirements input:checked'))
                    .map(child => child.value);
            val = val.toString()
        }

        const controlGroup =
            state.questions[idx] &&
            state.questions[idx].attributes &&
            state.questions[idx].attributes.controlGroup;

        if (controlGroup) {
            if (!obj[controlGroup]) obj[controlGroup] = {};
            obj[controlGroup][name] = val;
        } else {
            obj[name] = val;
        }

        return obj;
    }, {});

    return values;
}
